const barCodeOptionsDesktop = {
    format: "CODE128",
    lineColor: "#000",
    width: 3,
    height: 120,
    textMargin: 12,
    fontSize:20,
    fontOptions: "bold",
    margin: 20,
}

const barCodeOptionsMobile = {
    format: "CODE128",
    lineColor: "#000",
    width: 3,
    height: 140,
    textMargin: 20,
    fontSize:30,
    fontOptions: "bold",
    margin: 15,
}

export default function clientCardBarCode(objectDOM) {
    const barcodeValue = objectDOM.dataset.code;

    var barCodeOptions = barCodeOptionsDesktop;
    if(objectDOM.dataset.type === 'mobile') {
       barCodeOptions = barCodeOptionsMobile;
    }
    import('jsbarcode').then(({default: JsBarcode}) => {
        JsBarcode(objectDOM, barcodeValue, barCodeOptions);
    });
}